The response from the `applyWithSeekButton` query.
